import React from 'react';
import { Card, Container, Row, Col, HeaderText, BodyText, Form } from 'shared-portal-component';
import { z } from 'zod';

import '@/components/organism/style.scss';
import { useAppDispatch } from '@/store';
import { verifyOtpThunk } from '@/store/thunks/auth/verifyOtpThunk';

const schema = z.object({
  username: z.string().email("Please enter a valid email").nonempty("Email is required"),
  otp: z.string().nonempty("OTP is required"),
});
type FormValues = z.infer<typeof schema>;

const fields = [
  {
    name: 'username',
    label: 'Username',
    placeholder: 'Your email address (where you received the Welcome email)',
    required: true,
    variant: 'outline' as const,
    type: 'email'
  },
  {
    name: 'otp',
    label: 'One-time Passcode (OTP)',
    placeholder: '12-character code from the Welcome email',
    required: true,
    variant: 'outline' as const,
    type: 'text'
  },
];

interface UsernameFormProps {
  formData?: { username?: string; otp?: string };
  onNext: (values: { username: string; otp: string }) => void;
  loading?: boolean;
  error?: string;
}

const UsernameForm: React.FC<UsernameFormProps> = ({ formData, onNext, loading, error }) => {
  const dispatch = useAppDispatch();
  return (
    <Container fluid>
      <Card>
        <Row spacing="md">
          <Col size={12}>
            <HeaderText text="Register your new user account" size="h2" className="header-text-auth" />
            <BodyText
            text="Please reference the Welcome email sent when your account was created to find your OTP."
            color="#000"
            className="body-text-auth"
            as="p"
          />
        </Col>
      </Row>
      <Form
        schema={schema}
        fields={fields}
        onSubmit={(values: FormValues) => {
          const normalizedValues = { ...values, username: values.username.toLowerCase() };
          void dispatch(verifyOtpThunk(normalizedValues)).then((action) => {
            if (verifyOtpThunk.fulfilled.match(action)) {
              onNext(normalizedValues);
            }
          });
        }}
      />
    </Card>
  </Container>
);
}
export default UsernameForm;
